import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.33284 0.443093C7.55222 0.425975 7.77536 0.417557 8 0.41748C8.22464 0.417557 8.44778 0.425972 8.66716 0.443093C12.7017 0.758115 14.4435 3.45312 15.6304 6.90944C16.2369 8.67603 16.0924 10.6132 15.2309 12.2622C14.8104 13.0671 14.3932 13.6082 13.7008 14.2464C12.1426 15.6826 10.2285 16.4175 8.04585 16.4175C8.03056 16.4175 8.01528 16.4174 8 16.4174C7.98472 16.4174 7.96944 16.4175 7.95415 16.4175C5.77148 16.4175 3.85738 15.6826 2.2992 14.2464C1.60681 13.6082 1.18962 13.0671 0.769125 12.2622C-0.0923382 10.6132 -0.236928 8.67603 0.369668 6.90944C1.55648 3.45312 3.29828 0.758121 7.33284 0.443093ZM8 13.2652C9.77864 13.2707 11.542 12.5665 12.7112 11.21C13.1468 10.7046 13.5993 9.85174 13.7673 9.21902C13.9368 8.58098 13.9522 7.50727 13.8001 6.92172C13.0009 3.84461 11.4755 1.46957 8 1.41748C4.52451 1.46957 2.99907 3.84461 2.19991 6.92172C2.04785 7.50727 2.06318 8.58098 2.23266 9.21902C2.40074 9.85174 2.85315 10.7046 3.28878 11.21C4.45798 12.5665 6.22136 13.2707 8 13.2652Z",
  fill: "#86899E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.35557 2.57844C7.74353 2.52048 8.25624 2.52048 8.6442 2.57844C10.7821 2.8989 11.6594 4.25668 12.1309 6.22418C12.4891 7.7192 12.5425 8.27261 12.3907 8.91888C11.9534 10.781 10.1228 12.0799 7.99989 12.0642C5.87696 12.0799 4.04639 10.781 3.60906 8.91888C3.45727 8.27261 3.51062 7.7192 3.86888 6.22418C4.34038 4.25666 5.21766 2.89891 7.35557 2.57844Z",
  fill: "#86899E"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }